import React from 'react'
import { Link } from 'react-router-dom'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import { reExportedColors, Text } from '../../../1elements'
import useTabsNav from './useTabsNav'
import { GenericErrorBoundary } from '../../../2compounds/GenericErrorBoundary'
import GoBackButton from '../../../1elements/Buttons/IconButtons/GoBackButton'

const useStyles = makeStyles(() => ({
  root: {
    minHeight: 'auto',
  },
  flexContainer: {
    gap: '2px'
  },
  tab: {
    borderRadius: '6px 6px 0px 0px',
    backgroundColor: '#9A9A9A',
    boxShadow: '1px 0px 5px 0px rgba(0, 0, 0, 0.25)',
    minHeight: '40px',
    minWidth: 82,
    padding: '8px 19px',
    transition: 'border .25s, background-color .25s',
    opacity: 1,
    '& p': {
      color: reExportedColors.WHITE ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    }
  },
  tabText: {
    color: reExportedColors.WHITE ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  active: {
    // opacity: '1 !important',
    border: '2px solid #8B1811',
    // backgroundColor: reExportedColors.RED, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    backgroundColor: '#ED1C24',

    '& p': {
      color: reExportedColors.WHITE ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    }
  },
  indicator: {
    backgroundColor: '#8B1811',
    zIndex: 1
  },
  content: {
    boxShadow: '0px 0px 3px #00000029',
    borderRadius: '0px 6px 6px 6px',
    marginLeft: 3,
    height: '88%',
    padding: '24px',
    position: 'relative',
    backgroundColor: '#fff'
    // overflowX: 'hidden',
  },
  contentMobile: {
    borderRadius: '0px 6px 6px 6px',
    marginLeft: 3,
    height: '86%',
    // padding: '17px 22px 27px 21px',
    position: 'relative'
  },
  scroller: {
    paddingTop: 5,
    paddingLeft: 3
  },
  goBackButton: {
    borderRadius: '4px',
    backgroundColor: reExportedColors.MEDIUM_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 43,
    height: 40,
    boxShadow: '0px 0px 3px #00000029',
    marginRight: '4px',
    marginTop: '4px',
    color: reExportedColors.WHITE ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
  },
  goBackWrapper: {
    position: 'absolute',
    right: 7,
    top: 10,
    zIndex: 2
  },
  goBackButtonFull: {
    borderRadius: '4px 0px 0px 4px',
    backgroundColor: reExportedColors.MEDIUM_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    transition: 'all 0.2s ease-in-out',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 28,
    height: 31,
    boxShadow: '0px 0px 3px #00000029'
  },
  tbs: {
    marginTop: '65px',
    display: 'flex'
  }
}))

export default function TabsNav ({ children }) {
  const classes = useStyles()
  const { tabs, id, activeTabValue } = useTabsNav()

  return (
    <>
      <Tabs
        value={activeTabValue}
        classes={{
          indicator: classes.indicator,
          root: classes.root,
          scroller: classes.scroller,
          flexContainer: classes.flexContainer
        }}
      >
        {tabs.map((tab, idx) => {
          const { custom_name, sys_name, isDisabledForPermission } = tab
          const tabLinkPath = `/tab/${sys_name}/${id}`
          const isConfiguration = id === undefined
          const isDisabled = isDisabledForPermission || isConfiguration
          return (
            <GenericErrorBoundary key={sys_name}>
              <Tab
                key={sys_name}
                label={<Text type='tabHeader' className={classes.tabText}>{custom_name}</Text>}
                value={idx}
                component={Link}
                to={tabLinkPath}
                classes={{
                  root: classes.tab,
                  selected: classes.active
                }}
                disabled={isDisabled}
                className={activeTabValue === idx ? `${classes.active}` : ''}
              />
            </GenericErrorBoundary>
          )
        })}
      </Tabs>

      <div className={classes.content}>
        <GoBackButton className={classes.goBackWrapper} />
        {children}
      </div>
    </>
  )
}
